import { isNumberControl, JsonFormsRendererRegistryEntry, rankWith } from '@jsonforms/core';
import controlRenderer from './NumberControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(1, isNumberControl),
};
